// extracted by mini-css-extract-plugin
module.exports = {"feeDetailsBody":"InvoiceFeeDetails_feeDetailsBody__oWiDF"};